
import { useResumeState } from "./useResumeState";
import { useResumeDownload } from "@/hooks/useResumeDownload";

/**
 * Hook for handling resume format selection and download
 */
export const useResumeFormat = () => {
  const { selectedResume, setShowFormatDialog, setSelectedFormat } = useResumeState();
  const { handleFormatDownload } = useResumeDownload();

  const onFormatSelect = async (format: "pdf" | "docx") => {
    setSelectedFormat(format);
    setShowFormatDialog(false);
    if (selectedResume) {
      await handleFormatDownload(selectedResume, format);
    }
  };

  return { onFormatSelect };
};
